import React, { lazy, useContext, useMemo, useEffect, useCallback } from "react";
import {
  BrowserRouter,
  NavLink,
  useParams,
  Switch,
  Route,
  Redirect,
  HashRouter,
  useHistory,
  useRouteMatch,
  useLocation
} from "react-router-dom";
import Context, { reducers, state as initState, useTranslation } from "./context";
import { getUserInfo } from "./api";
import { detectBrowser, detectOS, FocusSDK } from "@/utils";
import Icon from "./Icon";
import { message, Modal, Button } from "antd";
import CollapseBtn from "@/components/Joyspace/components/CollapseBtn";
import { SearchType } from "@/services/SearchService";
import Home from "./pages/Home";
import MySpace from "./pages/MySpace";
// import TeamSpace from './pages/TeamSpace';
// import Spaces from './pages/TeamSpace/Spaces';
// import SpacesDoc from './pages/TeamSpace/SpacesDoc';
import Follow from "./pages/Follow";
import Collections from "./pages/Collections";
import Knowledge from "./pages/Knowledge";
import Trashes from "./pages/Trashes";
import ErrorPage from "./pages/Error";
// import UploadBox from "@/components/Joyspace/components/UploadBox";
// import Search from "@/components/Search";
import events from "@/components/Joyspace/context/events";
// import SetFolder from './components/SetFolder';
import NavTree from "@/components/Joyspace/components/NavTree";
import { connect } from "dvajs";
import NewVersionGuide from "@/components/Joyspace/components/NewVersionGuide";
import HeadTitle from "@/components/HeaderTitle";
import { analysisLogCustom } from "@/utils/logAnalytics";
import "@jd/focus-joyspace-comps/dist/focus-joyspace-comps.cjs.development.css";
import bus from "@/utils/bus";
import MoveDragger from "./components/MoveDragger";
import { getJoySpaceDucc } from "@/components/Joyspace/util";
import { crossAppSwitch } from "@/utils/tools";
import MyTags from "./pages/MyTags";
import { JoyspaceRouterMap } from "./util";
// import AddMembers from './contextModal/AddUserMembers';
// const navlinks = [
//   { name: "home", to: "/joyspace/home", icon: "iconjs_ic_home" },
//   { name: "myspace", to: "/joyspace/myspace", icon: "iconjs_ic_me" },
//   { name: "teamspace", to: "/joyspace/teamspace", icon: "iconjs_ic_team" },
//   // { name: 'follow', to: '/joyspace/follow', icon: 'iconjs_ic_attention' },
//   {
//     name: "collections",
//     to: "/joyspace/collections",
//     icon: "iconjs_ic_collect",
//     clstag: "pageclick|keycount|focus_joyspace_01_1615797631505|7"
//   },
//   {
//     name: "trashes",
//     to: "/joyspace/trashes",
//     icon: "iconjs_ic_Recycle",
//     clstag: "pageclick|keycount|focus_joyspace_01_1615797631505|8"
//   }
// ];

function Index(props) {
  const params = useParams();
  const lang = useTranslation();
  const [user, setUser] = React.useState();
  const history = useHistory();
  const { path } = useRouteMatch();
  const location = useLocation();
  const { setSelectedKeys, selectedKeys, currentPath } = props;
  const [collapse, setCollapse] = React.useState(false);
  // const { currentRouterInfo, setSelectedKeys } = props;
  // const { t } = useTranslation('joyspace');
  // console.log('test111===============>', t('joyspace-document'));
  // const [modalVisible, changeModalVisible] = React.useState(false);
  const width = "220px";
  const isShowWiki = crossAppSwitch("wiki") || false;
  const [state, dispatch] = React.useReducer((state, action) => {
    let _action = action;
    if (typeof action === "string") {
      _action = { type: action };
    }
    if (_action.type in reducers) {
      return reducers[_action.type](state, _action);
    }
    return state;
  }, initState);
  useEffect(() => {
    if (!isShowWiki) {
      // 通过ducc，知识库入口支持动态配置
      const { updateTreeDataInfo, treeDataInfo } = props;
      const newTreeDataInfo = [...treeDataInfo];
      const index = newTreeDataInfo.findIndex((item) => item.id === "knowledge");
      if (index !== -1) {
        newTreeDataInfo.splice(index, 1);
        updateTreeDataInfo(newTreeDataInfo);
      }
    }
  }, []);
  useEffect(() => {
    getUserInfo()
      .then((data) => {
        if (data) {
          setUser(data);
        }
      })
      .catch(() => {
        // err.message && message.error(err.message);
      });
  }, [lang]);
  useEffect(() => {
    const handleRoute = (url) => {
      console.log(url, "url1111");
      history.push(url);
    };
    events.on("joyspace:location", handleRoute);
    return () => {
      events.off("joyspace:location", handleRoute);
    };
  }, [history]);
  useEffect(() => {
    const openFolder = ({ path }) => {
      if (!path) return;
      history.push(`/joyspace/${path}`);
    };
    FocusSDK.on("joypace:openFolder", openFolder);
    return () => {
      FocusSDK.off("joypace:openFolder", openFolder);
    };
  }, [history]);
  // useEffect(() => {
  //   console.log('[DEBUG] Location changed:', {
  //     pathname: location.pathname,
  //     currentSelectedKeys: props.selectedKeys,
  //     timestamp: new Date().toISOString()
  //   });

  //   if (/home/.test(location.pathname)) {
  //     setSelectedKeys(["home"]);
  //     console.log('[DEBUG] Set selectedKeys to ["home"] due to /home/ path match');
  //   }
  // }, [location, setSelectedKeys, props.selectedKeys]);

  // 新增：处理 joyspace 根路径的重定向逻辑 - 只在精确匹配 /joyspace 时执行
  useEffect(() => {
    console.log("[DEBUG] Checking for joyspace root redirect:", {
      pathname: location.pathname,
      selectedKeys: selectedKeys,
      isExactJoyspaceRoot: location.pathname === "/joyspace",
      timestamp: new Date().toISOString()
    });

    // 只有当路径精确等于 /joyspace 时才进行重定向，避免死循环
    if (location.pathname === "/joyspace") {
      console.log("[DEBUG] Processing joyspace root redirect:", {
        selectedKeys,
        hasSelectedKeys: selectedKeys.length > 0,
        firstSelectedKey: selectedKeys?.[0]
      });

      if (selectedKeys.length > 0) {
        const selectedKey = selectedKeys[0];
        // 根据 selectedKey 映射到对应的路由
        const targetRoute = JoyspaceRouterMap[selectedKey] || "";
        if (targetRoute) {
          console.log("[DEBUG] Redirecting based on selectedKeys:", {
            selectedKey,
            targetRoute
          });
          history.replace(targetRoute);
          return;
        }
      }
      const realPath = currentPath || "/joyspace/home";
      history.replace(realPath);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, selectedKeys, currentPath]);
  // if (!user) {
  //     return null;
  // }
  const urlPrefix = `${props.basename}/joyspace`;
  let onMousedown = document.getElementById("tabs_line"); // 透明线
  let weizhi = document.getElementById("joyspace-sidebar"); // 左侧列表
  let body = document.querySelector("body");
  // let elTrees = document.getElementsByClassName("first-level-node"); // 左侧列表
  // let botlie = document.querySelectorAll("#bottom-line");
  // 获取鼠标点击位置
  onMousedown?.addEventListener("mousedown", function (e) {
    // 鼠标按下时的位置
    let mouseDownX = e.clientX;
    let H = weizhi.offsetWidth;
    body.style.cursor = "n-resize";
    body.style.opacity = "1.1";
    body.style.position = "absolute";
    body.style.top = "0";
    body.style.left = "0";
    body.style.width = "100%";
    body.style.backgroundColor = "#fff";
    body.style.zIndex = "5000";
    let timer = null;
    clearTimeout(timer);

    timer = setTimeout(function () {
      document.addEventListener("mousemove", move);
      // resize抛出事件
    }, 200);
    function move(e) {
      let mouseMoveX = e.clientX;
      const width = mouseMoveX - mouseDownX + H;
      if (width < 210 || width > 380) {
        return;
      }
      weizhi.style.width = width + "px";
      // for (let i = 0; i < elTrees.length; i++) {
      //     elTrees[i].style.minWidth = width - 2 + 'px';
      // }
      events.emit("left-nav-resize", width);
    }
    function handleMouseup() {
      // evt.stopPropagation();
      // evt.preventDefault();
      // document.onmousemove = null;
      // document.onmouseup = null;
      body.style.cursor = "auto";
      // console.log(4444, width, weizhi.style.width);
      bus.emit("layout:topBarSearch", weizhi.style.width);
      document.removeEventListener("mousemove", move);

      // let timer: any = null;
      clearTimeout(timer);
      timer = setTimeout(function () {
        document.removeEventListener("mouseup", handleMouseup);
      }, 200);
    }
    // // (3) 鼠标弹起，就让鼠标移动事件移除
    document.addEventListener("mouseup", handleMouseup);
    // // // (3) 鼠标弹起，就让鼠标移动事件移除
    // document.addEventListener('mouseup', function (evt) {
    //     evt.stopPropagation();
    //     evt.preventDefault();
    //     document.onmousemove = null;
    //     document.onmouseup = null;
    //     body.style.cursor = 'auto';
    //     document.removeEventListener('mousemove', move);
    // });
  });
  const analysisLog = useCallback((e) => {
    if (!e) {
      return;
    }
    analysisLogCustom(e);
  }, []);
  useEffect(() => {
    document.addEventListener("click", analysisLog);
    return () => {
      document.removeEventListener("click", analysisLog);
    };
  });

  const htmlBody = (
    <>
      {/* <NewVersionGuide /> */}
      <div
        className={`joyspace joyspace-page-${params?.[0]} ${collapse ? "joyspace-collapse" : ""}`}
        onClick={() => {
          events.emit("hideContextMenus");
        }}
      >
        <MoveDragger getFolderInfo={props.getFolderInfo} />
        <CollapseBtn collapse={collapse} setCollapse={setCollapse} />
        <div
          className="joyspace-sidebar sidebar-common-styles"
          id="joyspace-sidebar"
          style={{
            width: width,
            display: collapse ? "none" : "block"
          }}
        >
          <div className="tabs_line" id="tabs_line" />
          <HeadTitle title="文档协同" />
          <NavTree />
        </div>
        <Switch>
          {/* <Route exact path={path} render={() => <Redirect to={`${path}/home`} />} /> */}
          <Route path={`${path}/home`} component={Home} />
          {/* 目前我的文件和共享文件都走MySpace代码 */}
          <Route path={`${path}/myspace`} component={MySpace} />
          <Route exact path={`${path}/teamspace`} component={MySpace} />
          <Route exact path={`${path}/mytags`} component={MyTags} />
          <Route path={`${path}/follow`} component={Follow} />
          {isShowWiki && <Route path={`${path}/wiki`} component={Knowledge} />}
          <Route path={`${path}/collections`} component={Collections} />
          <Route path={`${path}/trashes`} component={Trashes} />
          <Route path={`${path}/error`} component={ErrorPage} />
          {/* <Redirect to="/joyspace/home" /> */}
        </Switch>
      </div>
    </>
  );

  // let comp;
  //
  // if (process.env.REACT_APP_BUILD_ELECTRON !== 'true') {
  //     comp = <HashRouter basename={urlPrefix}>{body}</HashRouter>;
  // } else {
  //     comp = <BrowserRouter basename={urlPrefix}>{body}</BrowserRouter>;
  // }

  return (
    <Context.Provider
      value={{
        state,
        dispatch,
        user,
        urlPrefix,
        deleteFolderById: props.deleteFolderById,
        changeFolderInfoById: props.changeFolderInfoById,
        freshLeftTreeByFolderById: props.freshLeftTreeByFolderById,
        getCurrentRouterInfo: props.getCurrentRouterInfo,
        currentRouterInfo: props.currentRouterInfo,
        filterInfo: props.filterInfo,
        getFolderInfoById: props.getFolderInfoById,
        addFolderInfo: props.addFolderInfo,
        getFolderInfo: props.getFolderInfo
      }}
    >
      {htmlBody}
    </Context.Provider>
  );
}
function mapStateToProps({ joyspace }) {
  return {
    currentRouterInfo: joyspace.currentRouterInfo,
    filterInfo: joyspace.filterInfo,
    selectedKeys: joyspace.selectedKeys,
    treeDataInfo: joyspace.treeDataInfo,
    currentPath: joyspace.currentPath
  };
}

function mapDispatchToProps(dispatch) {
  return {
    deleteFolderById(data) {
      return dispatch({
        type: "joyspace/deleteFolderById",
        payload: { id: data }
      });
    },
    setSelectedKeys(data) {
      dispatch({ type: "joyspace/setSelectedKeys", payload: data });
    },
    setSelectTableArray(data) {
      return dispatch({ type: "joyspace/setSelectTableArray", payload: data });
    },
    changeFolderInfoById(data) {
      return dispatch({
        type: "joyspace/changeFolderInfoById",
        payload: { ...data }
      });
    },
    freshLeftTreeByFolderById(data) {
      return dispatch({
        type: "joyspace/freshLeftTreeByFolderById",
        payload: { ...data }
      });
    },
    getCurrentRouterInfo() {
      return dispatch({ type: "joyspace/getCurrentRouterInfo", payload: {} });
    },
    addFolderInfo(list) {
      return dispatch({ type: "joyspace/addFolderInfo", payload: { list } });
    },
    getFolderInfo(id) {
      return dispatch({ type: "joyspace/getFolderInfo", payload: { id } });
    },
    getFolderInfoById(id, params) {
      return dispatch({
        type: "joyspace/freshFolderTreeById",
        payload: {
          id,
          params
        }
      });
    },
    updateTreeDataInfo(data) {
      dispatch({ type: "joyspace/updateTreeDataInfo", payload: data });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(Index);
